import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import axios from "axios";
import { NavItem } from "react-bootstrap";
import "./AddVendorBankDetails.css"

function AddVendorBankDetails({setShowDetailForms,userType,formSubmitted}) {
  const [searchParm] = useSearchParams();
  const baseAPI = process.env.REACT_APP_API_URL;
  const [DataFilled, setDataFilled] = useState(false);
  const [filledData, setFilledData] = useState(null);
  const[edit,setEdit]=useState(false)
  const[showInputFields,setShowInptFields]=useState(false)
  const[isEditMode,setIsEditMode]=useState(true)
  const [BankDetailForm, setBankDetailForm] = useState({
    HolderName: "",
    BankName: "",
    AccountNum: "",
    ReAccountNum: "",
    City: "",
  });

  useEffect(() => {
    if (searchParm.get("vendorID") != null) {
      checkDataFilled(searchParm.get("vendorID"));
      setBankDetailForm({
        ...BankDetailForm,
        VendorGUID: searchParm.get("vendorID"),
        CreatedBy:userType,
          ModifiedBy:"null",

      });
    }
  }, []);

// console.log(BankDetailForm)

  function checkDataFilled(id) {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    axios
      .get(`${baseAPI}admin/GETVendorBankGUID?VendorID=${id}`)
      .then((response) => {
        if (response.data.data[0].VendorGUID != null) {
          setFilledData(response.data.data);
          setBankDetailForm(response.data.data[0])

        }
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }

  function handleChange(e) {
    const { name, value } = e.target;
    setBankDetailForm({
      ...BankDetailForm,
      [name]: value,
    })
  }

  function ResetForm() {
    setBankDetailForm({
      HolderName: "",
      BankName: "",
      AccountNum: "",
      ReAccountNum: "",
      City: "",
      VendorGUID: searchParm.get("vendorID"),
    });
  }

  function showClickedForm(){
    const newObj = {
      AddressForm: false,
      OtherDetailsForm: false,
      BankDetailsForm: false,
      ContactDetailsForm: false,
      TermsForm: false
    }

    newObj.ContactDetailsForm = true;
    setShowDetailForms(newObj)
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    let updatedForm={}
    if (BankDetailForm && BankDetailForm.BankDetailId !== 0) {
       updatedForm = {
          ...BankDetailForm,
          CreatedBy:userType
      };
      
    }
    else{
      updatedForm={
        ...BankDetailForm,
        BankDetailId:0
      }
    }
    for (const key in BankDetailForm) {
      if (BankDetailForm[key] === "") {
        alert("All fields are mandatory. Please fill out all fields.");
        return;
      }
    }
   
   
    let hidden = document.getElementById("hidden");
    if (BankDetailForm.AccountNum != BankDetailForm.ReAccountNum) {
      hidden.style.display = "block";
      return;
    }
    showClickedForm()
    hidden.style.display = "none";
    try {
      const { ReAccountNum, ...formData } = BankDetailForm;
      const response = await axios.post(
        `${baseAPI}Admin/AddVendorBankDetail`,
        updatedForm
      );
      checkDataFilled(searchParm.get("vendorID"));
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  function AddMoreAccounts() {
setShowInptFields(true)
    setBankDetailForm({
      VendorGUID:searchParm.get("vendorID"),
      HolderName: "",
      BankName: "",
      AccountNum: "",
      ReAccountNum: "",
      City: "",
    })
  }

  function updateCurrentBankDetail(data){
setBankDetailForm(data)
setEdit(true)
setShowInptFields(true)
  }

  function cancelEdit(){
    setShowInptFields(false)
  }

  return (
    <div className="container-fluid" style={{position: "relative",paddingBottom:"30px"
     }}>
    <div  className={` ${userType === "admin" ? "admin_type_bank_list_main-div" : ""}`}>
    {filledData===null?
              <div  className={` vendor_bank_detail_table_main_div ${userType === "admin" ? "vendor_bank_detail_table_main_div_admin" : ""}`}>

              <table  style={{ width: "100%"}}>
    
              <tbody
    className="row"
  >
    <div className="col-lg-6 col-md-6 col-sm-6">
   

<tr>
     <td>
        Account Holder Name
      </td>
    <input
        type="text"
        name="HolderName"
        value={BankDetailForm.HolderName}
        placeholder="Please Enter*"
        onChange={handleChange}
      />
    </tr>

<tr>
    <td style={{color:"red"}}>
        Account Number
      </td>

    <input
        type="number"
        name="AccountNum"
        value={parseInt(BankDetailForm.AccountNum)}
        placeholder="Please Enter*"
        onChange={handleChange}
        required
      />
    </tr>
    <tr>
   <td>
        City
      </td>

    <input
        type="text"
        name="City"
        value={BankDetailForm.City}
        placeholder="Please Enter*"
        onChange={handleChange}
        required
      />
    </tr>
    </div>
    <div className="col-lg-6 col-md-6 col-sm-6">
    <tr>
     <td>
        Bank Name
      </td>

    <input
        type="text"
        name="BankName"
        value={BankDetailForm.BankName}
        placeholder="Please Enter*"
        onChange={handleChange}
      />
    </tr>
<tr>
<td style={{color:"red"}}>
Re-Enter Account Number
      </td>

    <input
        type="number"
        name="ReAccountNum"
        value={parseInt(BankDetailForm.ReAccountNum)}
        placeholder="Please Enter*"
        onChange={handleChange}
        required
      />
      <h6 id="hidden" style={{ color: "red", display: "none" }}>
        Re-Enter Account Number does not match with Account Number
      </h6>
    </tr>

    </div>
  </tbody>
              </table>
    
              <br />
              <hr />
              <div style={{marginBottom:"38px"}}  className={`reset-addSupplier-button ${userType === "admin" ? "admin_type_bank_buttons_main_div" : ""}`}>
                {edit?
     <button
     type="submit"
     onClick={handleSubmit}
     style={{
       backgroundColor: "#5B489D",
       color: "white",
     }}
    >
    Update
    </button>
    :
    formSubmitted?
    null
                :
                <button
                type="submit"
                onClick={handleSubmit}
                style={{
                  backgroundColor: "#5B489D",
                  color: "white",
                }}
               >
               Next
               </button>
                }
                
                {formSubmitted?
              null
            :
                   <button
                   onClick={cancelEdit}
                   style={{
                     backgroundColor: "white",
                     color: "red",
                     border:"none"

                   }}
                 >
                   Cancel
                 </button>
            }
              
           
            
              </div>
            </div>
    :
    showInputFields?
    <div className="row">
 <div  className={`vendor_bank_detail_table_main_div ${userType === "admin" ? "vendor_bank_detail_table_main_div_admin" : ""}`}>

<table  style={{ width: "100%"}}>

  <tbody
    className="row"
  >
    <div className="col-lg-6 col-md-6 col-sm-6">
   

<tr>
     <td>
        Account Holder Name
      </td>
    <input
        type="text"
        name="HolderName"
        value={BankDetailForm.HolderName}
        placeholder="Please Enter*"
        onChange={handleChange}
      />
    </tr>

<tr>
    <td style={{color:"red"}}>
        Account Number
      </td>

    <input
        type="number"
        name="AccountNum"
        value={parseInt(BankDetailForm.AccountNum)}
        placeholder="Please Enter*"
        onChange={handleChange}
        required
      />
    </tr>
    <tr>
   <td>
        City
      </td>

    <input
        type="text"
        name="City"
        value={BankDetailForm.City}
        placeholder="Please Enter*"
        onChange={handleChange}
        required
      />
    </tr>
    </div>
    <div className="col-lg-6 col-md-6 col-sm-6">
    <tr>
     <td>
        Bank Name
      </td>

    <input
        type="text"
        name="BankName"
        value={BankDetailForm.BankName}
        placeholder="Please Enter*"
        onChange={handleChange}
      />
    </tr>
<tr>
<td style={{color:"red"}}>
Re-Enter Account Number
      </td>

    <input
        type="number"
        name="ReAccountNum"
        value={parseInt(BankDetailForm.ReAccountNum)}
        placeholder="Please Enter*"
        onChange={handleChange}
        required
      />
      <h6 id="hidden" style={{ color: "red", display: "none" }}>
        Re-Enter Account Number does not match with Account Number
      </h6>
    </tr>

    </div>
  </tbody>
</table>

<br />
<hr />
<div style={{marginBottom:"38px"}}  className={`reset-addSupplier-button ${userType === "admin" ? "admin_type_bank_buttons_main_div" : ""}`}>
  {edit?
<button
type="submit"
onClick={handleSubmit}
style={{
backgroundColor: "#5B489D",
color: "white",
}}
>
Update
</button>
  :
  formSubmitted?
    null
    :
  <button
  type="submit"
  onClick={handleSubmit}
  style={{
    backgroundColor: "#5B489D",
    color: "white",
  }}
 >
 Next
 </button>
  }
{formSubmitted?
null
:
     <button
     onClick={cancelEdit}
     style={{
       backgroundColor: "white",
       color: "red",
       border:"none"

     }}
   >
     Cancel
   </button>
}


</div>
</div>
    <div className="bank_details_list_main-div">
           <table className={`col-lg-12 col-md-12 col-sm-12${userType !== "admin" ?"vendor_type_bank_detail_list":""}`}>
          <thead>
            <tr className="supplierListHeading">
                <th >S.No.</th>
              <th >Account Holder Name</th>
              <th >Bank Name</th>
              <th >Account Number</th>
              <th >City</th>
              {formSubmitted?
              null
            :
              <th>Action</th>
            }
            </tr>     
          </thead>
          <tbody>
            {filledData !== null ? (
              filledData.map((data, index) => (
                <tr key={index}>
                                      <td s >{data.BankDetailId}</td>
                  <td >{data.HolderName}</td>
                  <td >{data.BankName}</td>
                  <td >{data.AccountNum}</td>
                  <td >{data.City}</td>
                  {formSubmitted?
              null
            :
                  <td style={{cursor:"pointer"}} onClick={()=>updateCurrentBankDetail(data)}>Edit</td>
}
                  </tr>
              ))
            ) : 
            
            (
              <tr>
                {/* {} */}
              </tr>
            )}
          </tbody>
        </table>
          <h4
            style={{
              fontSize: "17px",
              color: "blue",
              marginTop: "31px",
              cursor: "pointer",
            }}
            onClick={AddMoreAccounts}
          >
            + Add More Bank Accounts
          </h4>
        </div>
    </div>
  :

        <div className="bank_details_list_main-div">
           <table className={`${userType !== "admin" ?"vendor_type_bank_detail_list":""}`}>
          <thead>
            <tr className="supplierListHeading">
                <th >S.No.</th>
              <th >Account Holder Name</th>
              <th >Bank Name</th>
              <th >Account Number</th>
              <th >City</th>
              {formSubmitted?
              null
              :
              <th>Action</th>
              }
            </tr>     
          </thead>
          <tbody>
            {filledData !== null ? (
              filledData.map((data, index) => (
                <tr key={index}>
                                      <td s >{data.BankDetailId}</td>
                  <td >{data.HolderName}</td>
                  <td >{data.BankName}</td>
                  <td >{data.AccountNum}</td>
                  <td >{data.City}</td>
                  {formSubmitted?
                  null
                :
                  <td style={{cursor:"pointer"}} onClick={()=>updateCurrentBankDetail(data)}>Edit</td>
                }
                  </tr>
              ))
            ) : 
            
            (
              <tr>
                {/* {} */}
              </tr>
            )}
          </tbody>
        </table>
        {formSubmitted?
        null:
          <h4
            style={{
              fontSize: "17px",
              color: "blue",
              marginTop: "31px",
              cursor: "pointer",
            }}
            onClick={AddMoreAccounts}
          >
            + Add More Bank Accounts
          </h4>
        }
        </div>
}
    </div>

    </div>
  );
}

export default AddVendorBankDetails;
